import '../styles/style.css';
import '../styles/terms.css';
import { NavBar } from '../components';

const DeleteTerms = () => {
    return (
        <>
            <div className='authNav'>
                <NavBar updateOpenSearchModal={() => null} />
            </div>
            <div className='c18 c23 doc-content'>
                <div style={{paddingBottom:"100px"}}>
                    <p className="c3"><span className="c20">USER ACCOUNT AND DATA DELETION REQUEST</span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c3"><span className="c11">User Account Deletion Process</span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c3"><span className="c8">Users can initiate an account deletion via <b>Website</b> or <b>Mobile App</b> using the following steps:</span></p>
                    <ul className="c15 lst-kix_list_1-0 start">
                        <li className="c6 c14 li-bullet-0" style={{paddingTop:'20px'}}><span className="c8">Step 1: Navigate to <a className="c24" href="https://www.ticki.co" target={'_blank'} rel="noreferrer">Ticki</a> or <b>Mobile App</b>, Login with your account credentials.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 2: Navigate to profile page.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 3: Click on the three dotted menu at the top right corner.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 4: Navigate to <b>Manage Account</b> &gt; <b>Personal Information</b>, then scroll to the bottom and click on "Delete Account".</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 5: On confirmation prompt, if you wish to process, then click on <b>"Done"</b>.</span></li>
                    </ul>

                    <p className="c2"><span className="c0"></span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c3"><span className="c11">User Data Deletion Process</span></p>
                    <p className="c2"><span className="c0"></span></p>
                    <p className="c3"><span className="c8">Users can initiate an data deletion via <b>Website</b> or <b>Mobile App</b> using the following steps:</span></p>
                    <ul className="c15 lst-kix_list_1-0 start">
                        <li className="c6 c14 li-bullet-0" style={{paddingTop:'20px'}}><span className="c8">Step 1: Navigate to <a className="c24" href="https://www.ticki.co" target={'_blank'} rel="noreferrer">Ticki</a> or <b>Mobile App</b>, Login with your account credentials.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 2: Navigate to profile page.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 3: Click on the three dotted menu at the top right corner.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 4: Navigate to <b>Help Center</b>.</span></li>
                        <li className="c6 c14 li-bullet-0"><span className="c8">Step 5: Fill the form with information you need us to delete and click on <b>Submit</b>.</span></li>
                    </ul>
                    
                </div>
            </div>
        </>
    )
}

export default DeleteTerms;